import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warehouse",
  "use": "icon-warehouse-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-warehouse\"><defs><style type=\"text/css\"></style></defs><path d=\"M453.48 122.26l-331.02 328.2c-15.52 15.39-24.24 36.26-24.24 58.02v335.24c0 45.32 37.05 82.05 82.75 82.05h662.04c45.7 0 82.75-36.74 82.75-82.05V508.48c0-21.76-8.72-42.63-24.24-58.02L570.5 122.26c-32.3-32.04-84.7-32.04-117.02 0z m182.65 639.41H387.87v-82.05h248.26v82.05z m0-164.1H387.87v-82.05h248.26v82.05z\" p-id=\"6775\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/warehouse.svg
// module id = BupX
// module chunks = 125